import { render, staticRenderFns } from "./BusinessPartnerResponsibleList.vue?vue&type=template&id=48f05618&"
import script from "./BusinessPartnerResponsibleList.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerResponsibleList.vue?vue&type=style&index=0&id=48f05618&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports